const Modal = {
  init(target) {
    const closeBtn = target.querySelector('.modal__close')
    const iframe = target.querySelector('iframe')

    closeBtn.addEventListener('click', () => this.close(iframe, target))
    target.addEventListener('click', (e) => this.onClick(e, iframe, target))
  },

  onClick(e, iframe, target) {
    e.stopPropagation()

    if (!iframe.contains(e.target)) {
      this.close(iframe, target)
    }
  },

  close(iframe, target) {
    iframe.src = ''
    target.classList.remove('modal--open')
  },
}

export default Modal
